import { featureItems } from "@/mocks/features";

export default function FeatureGridSection() {
  return (
    <section id="features" className="py-16 md:py-24 px-6 md:px-10 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        <div className="mb-12 md:mb-16">
          <p className="text-xs md:text-sm text-accent-600 font-medium tracking-wide uppercase mb-2">Why Choose Us</p>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 max-w-xl">
            Why Smart Shoppers Use Pandabuy Sheet
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          <div className="rounded-2xl bg-foreground-900 p-6 md:p-8 flex flex-col justify-between min-h-[320px]">
            <div>
              <div className="w-12 h-12 rounded-full bg-primary-500/20 flex items-center justify-center mb-6">
                <i className="ri-bar-chart-2-line text-xl text-primary-400"></i>
              </div>
              <h3 className="text-xl md:text-2xl font-heading font-bold text-white mb-3">{featureItems[0].title}</h3>
              <p className="text-sm text-white/60 leading-relaxed">{featureItems[0].description}</p>
            </div>
            <span className="text-xs text-white/40 mt-6 inline-block">01</span>
          </div>

          <div className="rounded-2xl overflow-hidden relative min-h-[320px]">
            <img
              src="https://readdy.ai/api/search-image?query=Artistic%20flatlay%20of%20coordinated%20fashion%20outfit%20with%20neutral%20toned%20garments%20on%20textured%20cream%20paper%20background%2C%20soft%20natural%20lighting%2C%20editorial%20styling%20photography%2C%20warm%20beige%20and%20sand%20palette%2C%20high%20detail%2C%20aesthetic%20composition&width=800&height=1000&seq=feature-outfit-v2&orientation=portrait"
              alt="Coordinated outfit flatlay with neutral garments"
              title="Outfit Breakdown Analysis - Pandabuy Sheet"
              className="absolute inset-0 w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
            <div className="absolute top-4 left-4">
              <span className="px-3 py-1.5 rounded-full bg-white/20 backdrop-blur-sm text-white text-xs whitespace-nowrap">
                <i className="ri-shirt-line mr-1"></i>Outfit Analysis
              </span>
            </div>
            <div className="absolute bottom-6 left-6 right-6">
              <h3 className="text-xl md:text-2xl font-heading font-bold text-white mb-2">{featureItems[1].title}</h3>
              <p className="text-sm text-white/70 leading-relaxed">{featureItems[1].description}</p>
            </div>
          </div>

          <div className="rounded-2xl bg-background-50 border border-background-200/70 p-6 md:p-8 flex flex-col justify-between min-h-[320px]">
            <div>
              <h3 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-3">{featureItems[2].title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed mb-6">{featureItems[2].description}</p>
            </div>
            <div className="rounded-xl overflow-hidden h-32">
              <img
                src="https://readdy.ai/api/search-image?query=Clean%20product%20photography%20of%20fashion%20accessories%20with%20visible%20price%20comparison%20tags%20on%20cream%20surface%2C%20soft%20natural%20lighting%2C%20editorial%20aesthetic%2C%20warm%20neutral%20tones%2C%20high%20detail%2C%20organized%20retail%20display&width=800&height=400&seq=feature-price-v2&orientation=landscape"
                alt="Price tracking with fashion accessories"
                title="Price Tracking - Pandabuy Sheet"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 md:gap-6 mt-5 md:mt-6">
          <div className="rounded-2xl bg-background-50 border border-background-200/70 p-6 md:p-8">
            <div className="w-12 h-12 rounded-full bg-accent-100 flex items-center justify-center mb-5">
              <i className="ri-brain-line text-xl text-accent-600"></i>
            </div>
            <h3 className="text-lg md:text-xl font-heading font-bold text-foreground-900 mb-2">{featureItems[3].title}</h3>
            <p className="text-sm text-foreground-600 leading-relaxed">{featureItems[3].description}</p>
          </div>
          <div className="rounded-2xl bg-background-50 border border-background-200/70 p-6 md:p-8">
            <div className="w-12 h-12 rounded-full bg-secondary-100 flex items-center justify-center mb-5">
              <i className="ri-flashlight-line text-xl text-secondary-600"></i>
            </div>
            <h3 className="text-lg md:text-xl font-heading font-bold text-foreground-900 mb-2">{featureItems[4].title}</h3>
            <p className="text-sm text-foreground-600 leading-relaxed">{featureItems[4].description}</p>
          </div>
        </div>
      </div>
    </section>
  );
}